import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { useVisualViewportHeight } from '@leanpay/hooks'
import { A11yAnnouncer } from '@leanpay/ui'

import { useAppStore } from './app-store'
import CheckoutHeader from './components/checkout-header/checkout-header'
import { isMarketHun, isMarketRom, isMarketSlo } from 'library/constants'
import { lazyWithRetry } from 'library/lazy-with-retry'
import { handleCheckoutProgress, shouldShowCancelIcon } from 'library/utils'

import { CheckoutErrorBoundary } from './shared/error-boundary/checkout-error-boundary'

const MainAppHUN = lazyWithRetry(() => import('./checkout-markets/hun/main-app-hun'))
const MainAppROM = lazyWithRetry(() => import('./checkout-markets/rom/main-app-rom'))
const MainAppSLO = lazyWithRetry(() => import('./checkout-markets/slo/main-app-slo'))

// Map of language names in their native language
const languageNames = {
    // English is always "English"
    en: 'English',
    // Native language names
    sl: 'slovenščina',
    hu: 'magyar',
    ro: 'română',
}

const MainLayout = () => {
    const location = useLocation()
    const { progress, setProgress, isAuthenticated } = useAppStore()

    useVisualViewportHeight()

    //Show cancel icon only if user is authenticated and screen is not one of the excluded paths
    const showCancelIcon = isAuthenticated && shouldShowCancelIcon()

    useEffect(() => {
        handleCheckoutProgress(location.pathname, setProgress)
    }, [location.pathname, setProgress])

    const renderApp = () => {
        if (isMarketSlo) return <MainAppSLO />
        else if (isMarketRom) return <MainAppROM />
        else if (isMarketHun) return <MainAppHUN />

        throw Error('Error')
    }

    return (
        <>
            <div className="main-layout flex-1 self-center flex flex-col items-center overflow-y-auto overscroll-none min-[900px]:scroll-smooth max-w-[840px] w-full bg-lp-grey2 rounded-lg min-[900px]:max-h-[95vh] min-[900px]:my-auto max-[899px]:rounded-none max-[899px]:max-w-full max-[899px]:h-full max-[899px]:pb-30">
                <A11yAnnouncer />
                <CheckoutErrorBoundary>
                    <CheckoutHeader showCancelIcon={showCancelIcon} progress={progress}>
                        {renderApp()}
                    </CheckoutHeader>
                </CheckoutErrorBoundary>
            </div>
        </>
    )
}

export default MainLayout
